import { render, staticRenderFns } from "./QuestionsSection.vue?vue&type=template&id=64672c66"
import script from "./QuestionsSection.vue?vue&type=script&lang=js"
export * from "./QuestionsSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports